<template>
    <div id="form-container" ref="formContainer">
        <b-container fluid>
            <h1>
                Correct Social Security Number
            </h1>
            <div>
                Any SSN change may take up to one month to be processed by MDH.
            </div>
            <b-form class="mt-3">
                <b-row>
                    <b-col cols="4">
                        <BaseMaskedTextInput v-model="profile.ssn"
                                             :v="$v.profile.ssn"
                                             slug="ssn"
                                             label="Social Security Number"
                                             setId="ssn"
                                             mask="###-##-####"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                       You must upload a copy of your Social Security card.
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        Current attached file: <span>{{!attachment ? 'No file attached' : attachment.filename}}</span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <FileAttachment v-on:attachment-added="addAttachment"
                                        :attachment-type-options="opts.attachmentOptions"
                                        describedBy="attachment"
                                        id="attachment"
                        />
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col cols="2">
                        <b-button type="button" variant="primary" @click="showConfirmModal">Update</b-button>
                    </b-col>
                </b-row>
            </b-form>
            <b-modal id="confirm-modal" hide-header hide-footer>
                <h2>Confirm Social Security Number Change</h2>
                <hr/>
                <form ref="form" @submit.prevent="updateSsn">
                    You are requesting to change your social security number to {{profile.ssn}}.
                    <p class="mt-2">Press Confirm to submit this social security number change request or Cancel to return to the request view.</p>
                    <div>
                        <b-button @click="closeConfirmModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
                        <b-button type="submit" variant="primary">Confirm</b-button>
                    </div>
                </form>
            </b-modal>
        </b-container>
    </div>
</template>

<script>
import axios from "axios"
import axiosRetry from 'axios-retry'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
import { toastService } from "@/mixins/toastService"
import FileAttachment from "@/components/templates/input/FileAttachment";

axiosRetry(axios, { retries: 0,
    retryDelay: axiosRetry.exponentialDelay  })

export default {
    data: () => ({
        profile: {},
        opts: {
            attachmentOptions: []
        },
        attachment: null
    }),
    components:{
        FileAttachment
    },
    validations() {
        return {
            profile: {
                ssn: {
                    required,
                    minLength: minLength(11),
                    maxLength: maxLength(11)
                },
                attachment: { required },
            }
        }
    },
    methods: {
        initialize() {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/profile/user`)
                .then(response => {
                    this.profile = response.data
                })
        },
        loadAttachmentOptions(){
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachments/public/ssnTypes`, {ignoreHeader: true})
                .then(response => {
                    for(let type of response.data){
                        this.opts.attachmentOptions.push({
                            value: type.code,
                            text: type.description
                        })
                    }
                })
        },
        addAttachment(value){
            this.profile.attachment = value
            this.attachment = value
            setTimeout( () => this.$emit('attachment-complete'), 10000);
        },
        updateSsn() {
            this.$v.$touch()
            if (!this.$v.$invalid) {
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/change/ssn/`, this.profile)
                    .then(response => {
                        toastService.showRootToast("SSN Update", "Your Social Security Number change has been submitted.", "success", this.$root)
                    }) .catch(error => {
                        toastService.showRootToast("Error", "An error has occurred " , "danger", this.$root)
                    }).finally(()=>{
                    this.closeConfirmModal();
                })
            }
        },
        showConfirmModal(){
            this.$bvModal.show('confirm-modal');
        },
        closeConfirmModal(){
            this.$bvModal.hide('confirm-modal');
        },
    },
    created() {
        this.initialize()
        this.loadAttachmentOptions()
        document.title = "Correct Social Security Number - NAR"
    },
    mixins: [
        toastService
    ],
}
</script>